/**
 * Chapter theme config for home pages and widgets.
 * Maps Tailwind-style dotColor to hex.
 */
export const DOT_COLORS = {
  'bg-rose-300': '#fda4af',
  'bg-rose-400': '#fb7185',
  'bg-pink-400': '#f472b6',
  'bg-violet-400': '#a78bfa',
  'bg-amber-400': '#fbbf24',
  'bg-orange-400': '#fb923c',
  'bg-emerald-400': '#34d399',
  /** Pregnancy chapter — brighter mint-teal */
  'bg-mint-400': '#5EEAD4',
  'bg-gray-300': '#d1d5db',
};

export function resolveDotColor(dotColor) {
  if (!dotColor) return '#94a3b8';
  return DOT_COLORS[dotColor] || (dotColor?.startsWith('#') || dotColor?.startsWith('var(') ? dotColor : '#94a3b8');
}

/** Theme for each chapter: accent, accentBg, accentText, accentPillText, postButtonBg */
export const CHAPTER_THEMES = {
  ttc: {
    accent: '#7F77DD',
    accentBg: '#EEEDFE',
    accentText: '#534AB7',
    accentPillText: '#534AB7',
    postButtonBg: '#7F77DD',
  },
  pregnancy: {
    accent: '#14B8A6',
    accentBg: '#F0FDFA',
    accentText: '#0F766E',
    accentPillText: '#0F766E',
    postButtonBg: '#14B8A6',
    gradientEnd: '#CCFBF1',
  },
  motherhood: {
    accent: '#9B2942',
    accentBg: '#F5EAED',
    accentText: '#6B1C2E',
    accentPillText: '#6B1C2E',
    postButtonBg: '#9B2942',
    gradientEnd: '#FBEAF0',
  },
  menopause: {
    accent: '#BE185D',
    accentBg: '#FCE8F3',
    accentText: '#BE185D',
    accentPillText: '#9D174D',
    postButtonBg: '#BE185D',
  },
  'first-chapter': {
    accent: '#7F77DD',
    accentBg: '#EEEDFE',
    accentText: '#534AB7',
    accentPillText: '#534AB7',
    postButtonBg: '#7F77DD',
  },
  cycle: {
    accent: '#7F77DD',
    accentBg: '#EEEDFE',
    accentText: '#534AB7',
    accentPillText: '#534AB7',
    postButtonBg: '#7F77DD',
  },
  fertility: {
    accent: '#D4537E',
    accentBg: '#FBEAF0',
    accentText: '#D4537E',
    accentPillText: '#72243E',
    postButtonBg: '#D4537E',
  },
  postpartum: {
    accent: '#9B2942',
    accentBg: '#F5EAED',
    accentText: '#6B1C2E',
    accentPillText: '#6B1C2E',
    postButtonBg: '#9B2942',
    gradientEnd: '#FBEAF0',
  },
};
